import { __assign, __awaiter, __generator, __read } from "tslib";
import { getMainSettings, getXAnchorMailbox } from '.';
export function getHostAppSettings(searchInstrumenter, searchSettings) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, tokenProviders, identity, isGcc, xAnchorMailbox, mainSettings, bingTokenProvider, sharePointTokenProvider, graphTokenProvider, substrateTokenProvider, lokiTokenProvider, thorTokenProvider, odsTokenProvider, tenantFeedbackTokenProvider, isMsa, baseTokenSettings, enterpriseTokenSettings, tokenSettings, settings;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        searchSettings.getTokenProviders(),
                        searchSettings.getIdentity(),
                        searchSettings.getIsGcc(),
                        getXAnchorMailbox(searchSettings),
                        getMainSettings(searchInstrumenter, searchSettings),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 5]), tokenProviders = _a[0], identity = _a[1], isGcc = _a[2], xAnchorMailbox = _a[3], mainSettings = _a[4];
                    bingTokenProvider = tokenProviders.bingTokenProvider, sharePointTokenProvider = tokenProviders.sharePointTokenProvider, graphTokenProvider = tokenProviders.graphTokenProvider, substrateTokenProvider = tokenProviders.substrateTokenProvider, lokiTokenProvider = tokenProviders.lokiTokenProvider, thorTokenProvider = tokenProviders.thorTokenProvider, odsTokenProvider = tokenProviders.odsTokenProvider, tenantFeedbackTokenProvider = tokenProviders.tenantFeedbackTokenProvider;
                    isMsa = identity.isMsa;
                    baseTokenSettings = {
                        'searchux.api.autoSuggest.tokenProvider': substrateTokenProvider,
                    };
                    enterpriseTokenSettings = {
                        'searchux.api.bingForBusiness.tokenProvider': bingTokenProvider,
                        'searchux.api.delegateAutoSuggest.tokenProvider': substrateTokenProvider,
                        'searchux.api.graphMicrosoft.tokenProvider': graphTokenProvider,
                        'searchux.api.loki.tokenProvider': lokiTokenProvider,
                        'searchux.api.ods.tokenProvider': !isGcc ? odsTokenProvider : undefined,
                        'searchux.api.shareDialog.tokenProvider': sharePointTokenProvider,
                        'searchux.api.sharePoint.tokenProvider': sharePointTokenProvider,
                        'searchux.api.tenantFeedback.tokenProvider': tenantFeedbackTokenProvider,
                        'searchux.api.thor.tokenProvider': thorTokenProvider,
                    };
                    tokenSettings = __assign(__assign({}, baseTokenSettings), (!isMsa ? enterpriseTokenSettings : {}));
                    settings = __assign(__assign(__assign({}, mainSettings), tokenSettings), { 'searchux.xAnchorMailbox': xAnchorMailbox });
                    return [2 /*return*/, settings];
            }
        });
    });
}
//# sourceMappingURL=getHostAppSettings.js.map